import ImmutableRenderComponent from './immutable-render-component';
import QuestionUtil from './question-util';

import React from 'react';

/** Simple component that represents the Question Card displayed at the top of the Answer Page
  * with the "You Asked Aristo" heading.
  */
export default class QuestionCard extends ImmutableRenderComponent {
   static get propTypes() {
    return {
      question: React.PropTypes.string.isRequired,
    };
  }

  /** Renders a formatted multiple choice question.
    */
  render() {
    const questionJsx = QuestionUtil.renderQuestion(this.props.question, true);
    return(
      <div>
        <h1 className="no-bottom-margin text-center">You Asked Aristo:</h1>
        <div className="box-with-pointer">
          <div className="box-pointer"></div>
          <div className="box-with-pointer-content">
            {questionJsx}
          </div>
        </div>
      </div>
    );
  }
}
